import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Custom hook for dynamic back navigation with fallback.
 * Uses browser history to go back to the actual previous page.
 * Falls back to a specified route if there's no history.
 * 
 * @param fallbackRoute - The route to navigate to if there's no history
 * @returns A function that navigates back or to the fallback route
 */
export function useGoBack(fallbackRoute: string) {
  const navigate = useNavigate();
  
  const goBack = useCallback(() => {
    // Check if there's history to go back to
    // window.history.length > 1 means there's at least one page to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackRoute);
    }
  }, [navigate, fallbackRoute]);
  
  return goBack;
}
